// blockOverlayStorage — side-effectful helpers for the localStorage
// bucket that backs `useBlockOverlay`. Kept separate from the pure
// `blockOverlay.ts` reducer so unit tests can stay JSDOM-free.

import { deleteCloudOverlayScope } from '@/lib/threeD/blockOverlayCloud';

const PREFIX = 'fw.threeD.overlay.';

export function overlayStorageKey(docId: string): string {
  return `${PREFIX}${docId}`;
}

/** Remove every overlay blob for `docId`. Safe under SSR/private mode.
 *  When `options.cloud` is true, also fires the edge-fn DELETE. */
export function clearOverlayScope(
  docId: string,
  options?: { cloud?: boolean },
): number {
  if (typeof window === 'undefined') return 0;
  if (!docId) return 0;
  const exact = overlayStorageKey(docId);
  const childPrefix = `${exact}:`;
  let removed = 0;
  try {
    const victims: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (!k) continue;
      if (k === exact || k.startsWith(childPrefix)) victims.push(k);
    }
    for (const k of victims) {
      window.localStorage.removeItem(k);
      removed++;
    }
  } catch {
    /* quota / disabled storage */
  }
  if (options?.cloud) {
    void deleteCloudOverlayScope(docId);
  }
  return removed;
}
